import React from "react";

export const EditIcon: React.FC<{ size?: string, onClick?: () => void} > = ({ size = "64", onClick }) => {
  return (
    <svg
      className={onClick? "svg_button":""}
      onClick={onClick}
      width={size}
      height={size}
      viewBox={"0 0 64 64"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="matrix(0.13053941,0,0,0.13058559,-3.4921543e-4,-0.01136095)" fill="#3F90B5">
          <path
            d="m 313.548,152.387 -230.8,230.9 c -6.7,6.7 -6.7,17.6 0,24.3 3.3,3.3 7.7,5 12.1,5 4.4,0 8.8,-1.7 12.1,-5 l 230.8,-230.8 c 6.7,-6.7 6.7,-17.6 0,-24.3 -6.6,-6.8 -17.5,-6.8 -24.2,-0.1 z"
            id="path2" />
          <path
            d="m 431.148,191.887 c 4.4,0 8.8,-1.7 12.1,-5 l 25.2,-25.2 c 29.1,-29.1 29.1,-76.4 0,-105.4 l -34.4,-34.4 c -14.1,-14.1 -32.8,-21.8 -52.7,-21.8 -19.9,0 -38.6,7.8 -52.7,21.8 l -25.2,25.2 c -6.7,6.7 -6.7,17.6 0,24.3 l 115.6,115.6 c 3.3,3.2 7.7,4.9 12.1,4.9 z m -78.2,-145.9 c 7.6,-7.6 17.7,-11.8 28.5,-11.8 10.7,0 20.9,4.2 28.5,11.8 l 34.4,34.4 c 15.7,15.7 15.7,41.2 0,56.9 l -13.2,13.2 -91.4,-91.4 z"
            id="path4" />
          <path
            d="m 162.848,467.187 243.5,-243.5 c 6.7,-6.7 6.7,-17.6 0,-24.3 -6.7,-6.7 -17.6,-6.7 -24.3,0 l -239.3,239.5 -105.6,14.2 14.2,-105.6 228.6,-228.6 c 6.7,-6.7 6.7,-17.6 0,-24.3 -6.7,-6.7 -17.6,-6.7 -24.3,0 l -232.6,232.8 c -2.7,2.7 -4.4,6.1 -4.9,9.8 l -18,133.6 c -0.7,5.3 1.1,10.6 4.9,14.4 3.2,3.2 7.6,5 12.1,5 0.8,0 1.5,-0.1 2.3,-0.2 l 133.6,-18 c 3.7,-0.4 7.2,-2.1 9.8,-4.8 z"
            id="path6" />
        </g>
    </svg>
  );
};
